export function CookiesPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Política de Cookies</h1>

      <div className="prose prose-lg">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. ¿Qué son las cookies?</h2>
          <p>
            Las cookies son pequeños archivos de texto que los sitios web almacenan en su navegador. Estas cookies permiten que el sitio web recuerde información sobre su visita, su idioma preferido y otras opciones para hacer su próxima visita más fácil y hacer que el sitio sea más útil para usted.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Tipos de cookies que utilizamos</h2>
          
          <h3 className="text-xl font-semibold mt-6 mb-3">Cookies técnicas (necesarias)</h3>
          <p>
            Son aquellas que permiten al usuario la navegación a través de la página web y la utilización de las diferentes opciones o servicios que en ella existen.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">Cookies analíticas</h3>
          <p>
            Utilizamos Google Analytics para recopilar información anónima sobre el uso de nuestro sitio web. Estas cookies nos permiten analizar estadísticamente el uso que hacen los usuarios de nuestra web.
          </p>

          <h3 className="text-xl font-semibold mt-6 mb-3">Cookies de personalización</h3>
          <p>
            Son aquellas que permiten al usuario acceder al servicio con algunas características predefinidas en función de una serie de criterios (por ejemplo, el idioma o el tipo de navegador).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Cookies de terceros</h2>
          <p>
            Nuestro sitio web puede utilizar servicios de terceros que, por cuenta de Google y otras empresas, recopilan información con fines estadísticos y de prestación de servicios:
          </p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li>Google Analytics: análisis del tráfico web</li>
            <li>Redes sociales: botones de compartir y contenido de redes sociales</li>
            <li>Google Maps: visualización de mapas interactivos</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. ¿Cómo gestionar las cookies?</h2>
          <p>
            Puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones de su navegador de internet. En caso de que no permita la instalación de cookies en su navegador es posible que no pueda acceder a algunos de los servicios y que su experiencia en nuestra web pueda resultar menos satisfactoria.
          </p>
          <p className="mt-4">
            En los siguientes enlaces tiene a su disposición toda la información para configurar o deshabilitar las cookies en cada navegador:
          </p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li>
              <a href="https://support.google.com/chrome/answer/95647" className="text-brand hover:text-brand/80" target="_blank" rel="noopener noreferrer">
                Google Chrome
              </a>
            </li>
            <li>
              <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" className="text-brand hover:text-brand/80" target="_blank" rel="noopener noreferrer">
                Mozilla Firefox
              </a>
            </li>
            <li>
              <a href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" className="text-brand hover:text-brand/80" target="_blank" rel="noopener noreferrer">
                Microsoft Edge
              </a>
            </li>
            <li>
              <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" className="text-brand hover:text-brand/80" target="_blank" rel="noopener noreferrer">
                Safari
              </a>
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">5. Actualizaciones y cambios</h2>
          <p>
            Transcaravan Galicia SL puede modificar esta Política de Cookies en función de exigencias legislativas, reglamentarias, o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos.
          </p>
          <p className="mt-4">
            Por esta razón, aconsejamos a los usuarios que visiten periódicamente esta página para conocer los cambios sufridos en la misma.
          </p>
        </section>
      </div>
    </div>
  );
} 